"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Emitter = void 0;
class Emitter {
  _subscriptions = new Map();
  _emitting = Promise.resolve();
  _executing = Promise.resolve();
  emit(name, ...args) {
    this._emitting = this._emitting.then(async () => {
      try {
        const cb = this._subscriptions.get(name);
        if (!cb) return;
        const result = cb(...args);
        if (result instanceof Promise) {
          await result;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    });
  }
  run(cb) {
    const promiseState = new Promise((resolve, reject) => {
      this._executing = this._executing.then(async () => {
        try {
          const result = cb();
          if (result instanceof Promise) {
            await result;
          }
          resolve();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
          reject(e);
        }
      });
    });
    return {
      unwrap: () => promiseState
    };
  }
  on(name, cb) {
    this._subscriptions.set(name, cb);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const $this = this;
    return () => {
      if (cb === $this._subscriptions.get(name)) {
        $this._subscriptions.delete(name);
      }
    };
  }
  clearSubscriptions() {
    this._subscriptions = new Map();
  }
}
exports.Emitter = Emitter;
